<template>
  <div>
    <div class="px-4 pt-4">
      <div class="user-chat-nav float-right">
        <b-dropdown
          right
          variant="white"
          toggle-class="font-size-18 text-muted p-0"
        >
          <template v-slot:button-content>
            <i class="ri-more-2-fill" />
          </template>
          <b-dropdown-item @click="showChangeProfile = true">
            {{ $t(`${tt}.dropdown.edit`) }}
          </b-dropdown-item>
          <b-dropdown-item @click="showChangePassword = true">
            {{ $t('tabs.settings.change_password.title') }}
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item href="/logout">
            {{ $t('home.log_out') }}
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <h4 class="mb-0">
        {{ $t(`${tt}.title`) }}
      </h4>
    </div>

    <ProfileInfo />
    <!-- End profile user -->

    <form-change-profile :show.sync="showChangeProfile" />
    <form-change-password :show.sync="showChangePassword" />

    <!-- Start user-profile-desc -->
    <div class="p-4 user-profile-desc">
      <b-card
        no-body
        class="border custom-accordion"
      >
        <b-card-header>
          <h5 class="font-size-15 m-0">
            <i class="ri-user-2-line mr-2 align-middle d-inline-block" />
            {{ $t(`${tt}.about.title`) }}
          </h5>
        </b-card-header>
        <b-card-body>
          <div>
            <p class="text-muted mb-1">
              {{ $t(`${tt}.about.name.label`) }}
            </p>
            <h5 class="font-size-14">
              {{ profileName }}
            </h5>
          </div>

          <div class="mt-4">
            <p class="text-muted mb-1">
              {{ $t(`${tt}.about.email.label`) }}
            </p>
            <h5 class="font-size-14">
              {{ user.email }}
            </h5>
          </div>

          <div class="mt-4">
            <p class="text-muted mb-1">
              {{ $t(`${tt}.about.time_zone.label`) }}
            </p>
            <h5 class="font-size-14">
              {{ user.timezone }}
            </h5>
          </div>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import FormChangeProfile from "./Profile/Form/ChangeProfileFormProfileTabComponents";
import FormChangePassword from "./Profile/Form/ChangePasswordFormProfileTabComponents";
import ProfileInfo from './Profile/InfoProfileTabComponents';
import {fullName} from "../../utils/contactName";

export default {
  components: {
    ProfileInfo,
    FormChangeProfile,
    FormChangePassword,
  },
  data: () => ({
    tt: 'tabs.profile',
    showChangeProfile: false,
    showChangePassword: false,
  }),
  computed: {
    ...mapGetters('auth', ['user']),
    profileName() {
      return fullName(this.user);
    },
  },
};
</script>
